import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  grid-area: header;
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};

  &:empty { display: none; }
`

function AccommodationSameRoomOptionTileHeaderArea(props: PropsWithChildren) {
  return <Container {...props} />
}

export default AccommodationSameRoomOptionTileHeaderArea
